import React, { useEffect, useState } from "react";
import { api } from "@/contexts/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const sel = "h-9 w-full rounded-sm border border-[#0B132B]/15 bg-white px-2 text-sm";

export const BulkReassignDialog = ({ dealers, open, onClose, onDone }) => {
  const [opts, setOpts] = useState(null);
  const [agencyId, setAgencyId] = useState("");
  const [userId, setUserId] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setAgencyId(""); setUserId(""); api.get("/dealer-tools/import-options").then(({ data }) => setOpts(data)).catch(() => toast.error("Could not load agencies")); } }, [open]);
  const agents = (opts?.agents || []).filter((a) => !agencyId || !a.agency_id || a.agency_id === agencyId);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/dealers/bulk-reassign", { dealer_ids: dealers.map((d) => d.dealer_id), agency_id: agencyId || null, user_id: userId || null });
      if (data.failed?.length) toast.warning(`${data.updated.length} reassigned, ${data.failed.length} failed: ${data.failed[0].detail}`);
      else toast.success(`${data.updated.length} dealer${data.updated.length === 1 ? "" : "s"} reassigned`);
      onDone?.(); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Bulk reassign failed"); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-sm max-w-md" data-testid="bulk-reassign-dialog">
        <DialogHeader><DialogTitle>Reassign {dealers.length} dealer{dealers.length === 1 ? "" : "s"}</DialogTitle></DialogHeader>
        <ul className="text-xs text-[#6C757D] max-h-24 overflow-y-auto list-disc pl-4" data-testid="bulk-reassign-list">{dealers.map((d) => <li key={d.dealer_id}>{d.dealer_name}</li>)}</ul>
        <div className="space-y-3">
          <div><Label className="text-[10px] uppercase tracking-[0.14em] font-bold text-[#6C757D]">New agency</Label>
            <select value={agencyId} onChange={(e) => { setAgencyId(e.target.value); setUserId(""); }} className={sel} data-testid="bulk-reassign-agency"><option value="">— keep current —</option>{(opts?.agencies || []).map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}</select></div>
          <div><Label className="text-[10px] uppercase tracking-[0.14em] font-bold text-[#6C757D]">New Agent of Record</Label>
            <select value={userId} onChange={(e) => setUserId(e.target.value)} className={sel} data-testid="bulk-reassign-agent"><option value="">— keep current —</option>{agents.map((a) => <option key={a.id} value={a.id}>{a.name}{a.agency ? ` · ${a.agency}` : ""}</option>)}</select></div>
        </div>
        <div className="flex justify-end gap-2 mt-2">
          <Button variant="outline" onClick={onClose} className="h-9 rounded-sm">Cancel</Button>
          <Button onClick={save} disabled={busy || !opts || (!agencyId && !userId)} className="h-9 rounded-sm bg-[#0B132B] text-white" data-testid="bulk-reassign-save">{busy ? "Saving…" : "Reassign all"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
